import React, { useContext, useState } from "react";

import Day from './day';
//import ManageDays from './manage_days';

import Moment from 'moment'
Moment.locale('en-gb');

//get the context
import QuoteContext from "../../quote-context"

import { ICONS } from '../../../shared/icons';
import Icon from '../../../shared/iconComponent';

const Days = ({ siteId }) => {

	const {formData, formDispatcher, navigation, navigationDispatcher } = useContext(QuoteContext);

	let initialDays = [];

	if(formData.days > 0){

		for( let day=1; day <= formData.days; day++ ){

			let dayName = '';
			let displayDate = '';

			if(formData.date){
				const dateParts = formData.date.split('/');

				let currentDay = day === 1 ? dateParts[0] : parseInt(dateParts[0]) + (day-1);

				let objDate = Moment();
				objDate.set('year', Number(dateParts[2]) );
				objDate.set('month', Number(dateParts[1])-1 );  // April
				objDate.set('date', currentDay );
				objDate.set('hour', 4 );
				objDate.set('minute', 0);
				objDate.set('second', 0 );
				objDate.set('millisecond', 0);
				dayName = objDate.format("dddd");
				displayDate = objDate.format("DD/MM/YY");
			}

			let dayData = {
				id: day,
				dayName: dayName,
				displayDate: displayDate,
				events: [],
				hotel: false,
				superPackage: false,
				first: day == 1 ? true : false,
				last: formData.days == day ? true : false
			}

			formData.activities.map( (selectedEvent) => {
				if( selectedEvent.day == day ){
					dayData.events.push(selectedEvent);
				}
			})

			initialDays.push(dayData);
		}
	}

	if( formData.hotel ){
		let startingDayIndex = formData.hotel.day != undefined && formData.hotel.day != null ? formData.hotel.day-1 : 0;
		for( let i=1; i <= formData.hotel.nights; i++ ){
			initialDays[startingDayIndex++].hotel = formData.hotel;
		}
	}

	if( formData.superPackage ){
		let startingDayIndex = formData.superPackage.day != undefined && formData.superPackage.day != null ? formData.superPackage.day-1 : 0;
		for( let i=1; i <= formData.superPackage.nights; i++ ){
			initialDays[startingDayIndex++].superPackage = formData.superPackage;
		}
	}

	const removeDay = () => {
		//do we have any items on this day?
		let lastDay = initialDays[initialDays.length-1];
		if(lastDay.hotel || lastDay.superPackage || lastDay.events.length > 0 ){
			navigationDispatcher({ type: 'OPEN_MODAL', modal: './quote/modal/RemoveDay', title: 'Are you sure you want to delete this day?', payload: { day: lastDay }});
		} else {
			formDispatcher({type:"REMOVE_DAY"})
		}
		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'remove-day',
			trigger: 'web-js',
			data:  {
				day: initialDays[initialDays.length-1].displayDate
			}
		});
	}

	return (
		<div className="full-width-block white">
			<div className="full-width">
				<div className="align-content grid horizontal left no-padding wrap">
				
					{initialDays.map( (day, index) => (
						<Day
							siteId={siteId}
							key={`day-${index}`}
							currentDay={day}
							hasSuperPackages={navigation.destination.hasSuperPackages}
							userHasSelectedHotel={ !navigation.destination.hasSuperPackages && formData.hotel ? true : false}
							userHasSelectedSuperPackage={ navigation.destination.hasSuperPackages && formData.superPackage ? true : false }
							removeDay={removeDay}
						/>
					))}

					<div className="grid-item half">
						
						<button onClick={() => {
							formDispatcher({type:"ADD_DAY"})
							navigationDispatcher({
								type: 'TRACK_EVENT',
								action: 'event',
								category: 'click',
								name: 'add-day',
								trigger: 'web-js',
								data:  {
									currentDay: initialDays[initialDays.length-1].displayDate
								}
							});
						}} className="button full-width bg-dark-stag-light-hen large radius">
							<span className="icon icon-calplus icon-xl white left"></span>
							<p className="white no-mg-b">Add Another Day</p>
						</button>
						
					</div>
				</div>
			</div>
		</div>
	)
}

export default Days
